module.exports = __webpack_public_path__ + "img/icon-white-31.c1143029.svg";